import store from "../../store";
import router from "../../router";
import { is_it_client_reliance_type } from "@/backend/axios/organisation_config.js";
const module_that_allowed = {
    'logistics_manager': ['RIA','Reverse Logistics','Pending Approval'],
    'logistics_partner': ['RIA','FTA Tour Plan','Pending Approval'],
    'restock_manager' : ['RIMS','Disposition','Restock','Reverse','Pending Approval'],
    'markdown_manager' : ['RIMS','Disposition','MarkDown','Reverse','Pending Approval'],
    'supplier_manager' : ['RIMS','Disposition','RTV','Replacement','Brand Call Log','Chargeback','Reverse','Pending Approval'],
    'insurance_manager' : ['RIMS','Disposition','Insurance','Reverse','Pending Approval'],
    'cannibalization_manager' : ['RIMS','Disposition','Cannibalization','Reverse','Pending Approval'],
    'repair_manager' : ['RIMS','Disposition','Repair','Reverse','Pending Approval'],
    'grading_manager': ['RIA','Grading','Pending Approval'],
    'finance_manager': ['Claim Tracking','RIMS','Disposition','Liquidation','Reverse','Pending Approval'],
    'liquidation_manager': ['RIMS','Disposition','Liquidation','Reverse','Pending Approval'],
    'cycle_count_manager': ['RIMS','Cycle Count','Pending Approval'],
    'rtv_manager' : ['RIMS','Disposition','RTV','Reverse','Pending Approval'],
    'approver': ['RIMS','Pending Approval'],
    'management': ['RIMS','Disposition','Liquidation','Cannibalization','Repair','RTV','Restock','Replacement','Brand Call Log','Chargeback',
                    'MarkDown','Analytics','Dashboard','Insurance','Dispatch','Inwarding','Claim Tracking','PRD','Reverse','Pending Approval'],
    'warehouse_manager': ['RIMS','Disposition','PRD','Inwarding','Restock','MarkDown','Brand Call Log','Chargeback','Insurance','RTV','Replacement','Repair','Cannibalization',
                           'Liquidation','Transfer','Put Away/Pick Up','Cycle Count','Grading','Dispatch','Dashboard','Analytics','Reverse','Change Disposition','Pending Approval', "Generate Box ID's", 'Generate & Track IDs']
}
function moduleAccessFunc(role,module){
    if(role === 'warehouse_manager' && is_it_client_reliance_type()){
        module_that_allowed.warehouse_manager.push('RIA');
        module_that_allowed.warehouse_manager.push('Return Creation');
    }else if(role === 'warehouse_manager' && is_it_client_reliance_type()){
        module_that_allowed.warehouse_manager.push('Generate & Track IDs');
    }
    return role in module_that_allowed &&  !module_that_allowed[role].includes(module)
}
function signout(){
    store.commit("unsetCurrentUser");
    store.commit("unsetSelectedLot");
    store.commit("setCurrentWarehouse", { distribution_id: "" });
    router.replace("/");
}
function isOnlyViewAction(role,module){
    const warehouse_manager_action_restricted_module = ["Internal Assets","Production","Grading","Repair","Cannibalization","PRD","MarkDown",'Brand Call Log','Chargeback','Insurance','Liquidation']
    return (role == 'warehouse_manager' && warehouse_manager_action_restricted_module.includes(module)) || role == 'management'
}

export { moduleAccessFunc,module_that_allowed,signout,isOnlyViewAction}